import {Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {SharedModule} from "../../../../../../@shared/shared.module";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IReferral} from "../../../../../../@core/interfaces/user/user.interface";

@Component({
  selector: 'app-user-transaction',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, SharedModule],
  templateUrl: './user-transaction.component.html',
  styleUrls: ['./user-transaction.component.scss']
})
export class UserTransactionComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {userData: string},
    public dialogRef: MatDialogRef<UserTransactionComponent>,
  ) {
  }

  close() {
    this.dialogRef.close();
  }

}
